import styled from 'styled-components';
import { Col as Col_, Row as Row_ } from 'reactstrap';

export const Col = styled(Col_)`
    margin-bottom: 10px;
`;

export const Container = styled.div`
    margin-top: 20px;
`;

export const Row = styled(Row_)`
    margin-bottom: 10px;
    padding: 0px;
`;
